﻿/*---[ ESLint ]---*/
/*
    global _msg_notsaved: true,
           precommsgscenario
*/
window.precommsgscenario = function () {

    var LABEL_YES = "";
    var LABEL_NO = "";
    var LABEL_DELETE = "";

    function visibilityCalculateDDL(show) {
        var ddl = $("#CalculateGroupID").data("kendoDropDownList");

        if (ddl != null && ddl != undefined) {
            main.setHideKendoUIFormItem4("CalculateGroupID", show);
        }
    }

    return {

       initialize: function (labelYes, labelNo, labelDelete) {
            LABEL_YES = labelYes;
            LABEL_NO = labelNo;
            LABEL_DELETE = labelDelete;
        },

        initializeOverview: function () {
            $(".k-grid-add").click(function (e) {
                precommsgscenario.addScenario();
            });
        },

        initializeScenario: function (preComMsgScenarioId) {
            $(".k-grid-add").click(function (e) {
                precommsgscenario.addScenarioMsg(preComMsgScenarioId);
            });
        },

        initializeScenarioMsg: function (preComMsgScenarioMsgId) {
            $(".k-grid-add").click(function (e) {
                precommsgscenario.addScenarioMsgInfo(preComMsgScenarioMsgId);
            });

            var cbLCD = $("#LCD").data("kendoCheckBox");
            if (cbLCD != null && cbLCD != undefined) {
                visibilityCalculateDDL(cbLCD.element[0].checked);
            }
        },

        initializeScenarioMsgInfo: function (preComMsgScenarioMsgInfoId) {
            $(".k-grid-add").click(function (e) {
                precommsgscenario.addScenarioMsgInfoText(preComMsgScenarioMsgInfoId);
            });
        },

        // Scenario

        addScenario: function () {
            navigation.navigateToSpecificUrl("PreComMsgScenario/AddScenario");
        },

        showScenario: function (e) {
            // Show mode form 
            viewmode.setViewMode(ModuleActionViewEnum.Show);

            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));
            navigation.navigateToSpecificUrl("PreComMsgScenario/ShowScenario?preComMsgScenarioId=" + dataItem.PreComMsgScenarioID + "&breadcrumbLabel=" + dataItem.Label);
        },

        editScenario: function (e) {
            // Edit mode form 
            viewmode.setViewMode(ModuleActionViewEnum.Edit);

            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));
            navigation.navigateToSpecificUrl("PreComMsgScenario/EditScenario?preComMsgScenarioId=" + dataItem.PreComMsgScenarioID + "&breadcrumbLabel=" + dataItem.Label);
        },

        deleteScenario: function (e) {

            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            main.openActionsDialog(' ', LABEL_DELETE + " '" + dataItem.Label + "'",
                [{ text: LABEL_YES, action: function () { precommsgscenario.removeScenario(dataItem.PreComMsgScenarioID); main.closePopup(); } },
                { text: LABEL_NO, action: function () { main.closePopup(); }, primary: true }]);
        },

        removeScenario: function (preComMsgScenarioId) {
            $.ajax({
                type: "POST",
                url: appsettings.getUrl("PreComMsgScenario/DeleteScenario?preComMsgScenarioId=" + preComMsgScenarioId),
                success: function (responseData) {

                    if (responseData != undefined && responseData != null) {
                        if (responseData.Succesfully == false) {
                            main.openActionsDialog(' ', responseData.Message,
                                [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                        }
                    }

                    navigation.navigateToSpecificUrl("PreComMsgScenario/Overview");
                }
            });
        },


        // ScenarioMsg

        addScenarioMsg: function (preComMsgScenarioId) {
            navigation.navigateToSpecificUrl("PreComMsgScenario/AddScenarioMsg?preComMsgScenarioId=" + preComMsgScenarioId);
        },

        showScenarioMsg: function (e) {
            // Show mode form 
            viewmode.setViewMode(ModuleActionViewEnum.Show);

            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));
            navigation.navigateToSpecificUrl("PreComMsgScenario/ShowScenarioMsg?preComMsgScenarioMsgId=" + dataItem.PreComMsgScenarioMsgID + "&breadcrumbLabel=" + dataItem.Label);
        },

        editScenarioMsg: function (e) {            
            // Edit mode form 
            viewmode.setViewMode(ModuleActionViewEnum.Edit);

            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));   
            navigation.navigateToSpecificUrl("PreComMsgScenario/EditScenarioMsg?preComMsgScenarioMsgId=" + dataItem.PreComMsgScenarioMsgID + "&breadcrumbLabel=" + dataItem.Label);
        },

        deleteScenarioMsg: function (e) {
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            main.openActionsDialog(' ', LABEL_DELETE + " '" + dataItem.Label + "'",
                [{ text: LABEL_YES, action: function () { precommsgscenario.removeScenarioMsg(dataItem.PreComMsgScenarioMsgID); main.closePopup(); } },
                { text: LABEL_NO, action: function () { main.closePopup(); }, primary: true }]);
        },

        removeScenarioMsg: function (preComMsgScenarioMsgId) {
            $.ajax({
                type: "POST",
                url: appsettings.getUrl("PreComMsgScenario/DeleteScenarioMsg?preComMsgScenarioMsgId=" + preComMsgScenarioMsgId),
                success: function (responseData) {

                    if (responseData != undefined && responseData != null) {
                        if (responseData.Succesfully == false) {
                            main.openActionsDialog(' ', responseData.Message,
                                [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                        }
                    }

                    $("#MsgScenarioMsgGrid").data("kendoGrid").dataSource.read();
                }
            });
        },

        LCDChanged: function (e) {
            visibilityCalculateDDL(e.checked);
        },


        // ScenarioMsgInfo

        addScenarioMsgInfo: function (preComMsgScenarioMsgId) {
            navigation.navigateToSpecificUrl("PreComMsgScenario/AddScenarioMsgInfo?preComMsgScenarioMsgId=" + preComMsgScenarioMsgId);
        },

        showScenarioMsgInfo: function (e) {
            // Show mode form 
            viewmode.setViewMode(ModuleActionViewEnum.Show);

            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));
            navigation.navigateToSpecificUrl("PreComMsgScenario/ShowScenarioMsgInfo?preComMsgScenarioMsgInfoId=" + dataItem.PreComMsgScenarioMsgInfoID + "&breadcrumbLabel=" + dataItem.Label);
        },

        editScenarioMsgInfo: function (e) {
            // Show mode form 
            viewmode.setViewMode(ModuleActionViewEnum.Edit);

            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));
            navigation.navigateToSpecificUrl("PreComMsgScenario/EditScenarioMsgInfo?preComMsgScenarioMsgInfoId=" + dataItem.PreComMsgScenarioMsgInfoID + "&breadcrumbLabel=" + dataItem.Label);
        },

        deleteScenarioMsgInfo: function (e) {
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            main.openActionsDialog(' ', LABEL_DELETE + " '" + dataItem.Label + "'",
                [{ text: LABEL_YES, action: function () { precommsgscenario.removeScenarioMsgInfo(dataItem.PreComMsgScenarioMsgInfoID); main.closePopup(); } },
                { text: LABEL_NO, action: function () { main.closePopup(); }, primary: true }]);
        },

        removeScenarioMsgInfo: function (preComMsgScenarioMsgInfoId) {
            $.ajax({
                type: "POST",
                url: appsettings.getUrl("PreComMsgScenario/DeleteScenarioMsgInfo?preComMsgScenarioMsgInfoId=" + preComMsgScenarioMsgInfoId),
                success: function (responseData) {

                    if (responseData != undefined && responseData != null) {
                        if (responseData.Succesfully == false) {
                            main.openActionsDialog(' ', responseData.Message,
                                [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                        }
                    }

                    $("#MsgScenarioMsgInfoGrid").data("kendoGrid").dataSource.read();
                }
            });
        },


        // ScenarioMsgInfoText

        addScenarioMsgInfoText: function (preComMsgScenarioMsgInfoId) {
            navigation.navigateToSpecificUrl("PreComMsgScenario/AddScenarioMsgInfoText?preComMsgScenarioMsgInfoId=" + preComMsgScenarioMsgInfoId);
        },

        showScenarioMsgInfoText: function (e) {
            // Edit mode form 
            viewmode.setViewMode(ModuleActionViewEnum.Show);

            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));
            navigation.navigateToSpecificUrl("PreComMsgScenario/ShowScenarioMsgInfoText?preComMsgScenarioMsgInfoTextId=" + dataItem.PreComMsgScenarioMsgInfoTextID + "&breadcrumbLabel=" + dataItem.Text.slice(0, 15));
        },

        editScenarioMsgInfoText: function (e) {
            // Edit mode form 
            viewmode.setViewMode(ModuleActionViewEnum.Edit);

            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));
            navigation.navigateToSpecificUrl("PreComMsgScenario/EditScenarioMsgInfoText?preComMsgScenarioMsgInfoTextId=" + dataItem.PreComMsgScenarioMsgInfoTextID + "&breadcrumbLabel=" + dataItem.Text.slice(0, 15));
        },

        deleteScenarioMsgInfoText: function (e) {
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            main.openActionsDialog(' ', LABEL_DELETE + " '" + dataItem.Label + "'",
                [{ text: LABEL_YES, action: function () { precommsgscenario.removeScenarioMsgInfoText(dataItem.PreComMsgScenarioMsgInfoTextID); main.closePopup(); } },
                { text: LABEL_NO, action: function () { main.closePopup(); }, primary: true }]);
        },

        removeScenarioMsgInfoText: function (preComMsgScenarioMsgInfoTextId) {
            $.ajax({
                type: "POST",
                url: appsettings.getUrl("PreComMsgScenario/DeleteScenarioMsgInfoText?preComMsgScenarioMsgInfoTextId=" + preComMsgScenarioMsgInfoTextId),
                success: function (responseData) {

                    if (responseData != undefined && responseData != null) {
                        if (responseData.Succesfully == false) {
                            main.openActionsDialog(' ', responseData.Message,
                                [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                        }
                    }

                    $("#MsgScenarioMsgInfoTextGrid").data("kendoGrid").dataSource.read();
                }
            });
        },


        //--- LR ------------------------------------------------------------//

        LR_Initialize: function (notsaved) {
            _msg_notsaved = notsaved;
        },

        /**
        * Return label changed not saved
        */
        LR_LDataChangedNotSavedYet: function () {
            return _msg_notsaved;
        },

        LR_rightClicked: function () {
            listbox.moveItems("PreComMsgScenarioMsg_CplNotSelected", "PreComMsgScenarioMsg_CplSelected", "#LR_Validation", precommsgscenario.LR_LDataChangedNotSavedYet);
        },

        LR_leftClicked: function () {
            listbox.moveItems("PreComMsgScenarioMsg_CplSelected", "PreComMsgScenarioMsg_CplNotSelected", "#LR_Validation", precommsgscenario.LR_LDataChangedNotSavedYet);
        },

        LR_SaveButtonClicked: function (preComMsgScenarioMsgId) {
            var list = JSON.stringify($("#PreComMsgScenarioMsg_CplSelected").data("kendoListBox").dataItems());

            $.ajax({
                type: "POST",
                data:
                {
                    preComMsgScenarioMsgId: preComMsgScenarioMsgId,
                    assigned: list
                },
                url: appsettings.getUrl("PreComMsgScenario/LR_Submit"),
                success: function (responseData) {
                    if (responseData != null && responseData != undefined) {
                        form.showServerResponse("LRShowResponse", responseData);
                    }
                }
            });
        }

    }

}();